import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {FontVariant, Text, TextLink} from '@pexip/components';

import {TestId} from '../../../test/testIds';

import styles from './AudioOutputTestButton.module.scss';

export const AudioOutputTestButton: React.FC<{
    onClick: () => void;
    shouldPlay: boolean;
    isDisabled?: boolean;
}> = ({onClick, shouldPlay, isDisabled}) => {
    const {t} = useTranslation();
    const label = shouldPlay
        ? t('settings.playing-sound', 'Playing sound...')
        : t('settings.test-your-sound', 'Test your sound');
    const previousLabel = useRef(label);
    const [announcedLabel, setAnnouncedLabel] = useState<string>();

    useEffect(() => {
        if (previousLabel.current !== label) {
            setAnnouncedLabel(label);
            previousLabel.current = label;
        }
    }, [label]);

    return (
        <>
            <TextLink
                fontVariant={FontVariant.SmallLink}
                data-testid={TestId.LinkTestAudioOutput}
                onClick={onClick}
                isDisabled={isDisabled}
                className={styles.wrapper}
            >
                {label}
            </TextLink>
            <Text aria-atomic="true" aria-live="assertive" variant="hidden">
                {announcedLabel}
            </Text>
        </>
    );
};
